import React from "react";
import Image from "../../../components/AppImage";

const HeroSection = () => {
  return (
    <div className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Blur Effect */}
      <div className="absolute inset-0">
        <Image
          src="https://cf.bstatic.com/xdata/images/hotel/max1024x768/37080288.jpg?k=330b39bb617d5bc80270e1ca8104be56069981f8b6bd5a07741684d725c0d86d&o="
          alt="Guest House Sonja Krk"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 flex items-center justify-center h-full px-6">
        <div className="text-center text-white">
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold mb-4 tracking-tight">
            Guest House Sonja
          </h1>
          <p className="font-body text-lg sm:text-xl md:text-2xl text-white/90 max-w-2xl mx-auto leading-relaxed">
            Relax in beautifully designed apartments and rooms, moments away
            from the sea, old town, and local life.
          </p>
          <div className="mt-8 animate-bounce">
            <div className="w-6 h-10 border-2 border-white/60 rounded-full flex justify-center">
              <div className="w-1 h-3 bg-white/60 rounded-full mt-2 animate-pulse"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
